var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H9L7 9.5L5 7.5H6.5V0.5H7.5V7.5ZM3.5 5.5V6.5L1.835 8.5H3.5V9.5H0.5V8.5L2.165 6.5H0.5V5.5H3.5ZM2.5 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V4.5H1.5V3.5H2.5V4.5H3.5V1.5C3.5 0.95 3.055 0.5 2.5 0.5ZM2.5 2.5H1.5V1.5H2.5V2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAz);
export default __webpack_public_path__ + "static/media/sortAZ.0f8d7c5d.svg";
export { ForwardRef as ReactComponent };